// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vi9k","top":"styles_top__RE_Vo"};